import React from "react";
import { TextButton } from "@trainline/depot-web";
import useDisplayOptions from "../../../hooks/useDisplayOptions";
import useJourneyLeg from "../../../hooks/useJourneyLeg";
import CarrierInformation from "../../CarrierInformation";
import * as s from "./SubHeaderRow.module.css";
const SubHeaderRow = ({ legId }) => {
  const { carrierName, transportModeName, carrier, transportDesignation, timetableId, action } = useJourneyLeg(legId);
  const { displayTimetableIds } = useDisplayOptions();
  return /* @__PURE__ */ React.createElement("div", {
    className: s.subHeaderRow
  }, /* @__PURE__ */ React.createElement(CarrierInformation, {
    className: s.carrierInformation,
    name: carrierName,
    type: transportModeName,
    transportDesignation,
    timetableId,
    displayTimetableId: !!displayTimetableIds,
    route: carrier == null ? void 0 : carrier.route
  }), action && /* @__PURE__ */ React.createElement(TextButton, {
    typeSize: "small",
    text: action.label,
    buttonType: "inline",
    onClick: () => action.function(legId)
  }));
};
var SubHeaderRow_default = SubHeaderRow;
export {
  SubHeaderRow_default as default
};
